import React from 'react'
import { connect } from 'react-redux'
import ProfileFeed from '../components/ProfileFeed'
import { toJS } from '../../../util/ToJS'
import {distanceInWords, isEqual} from 'date-fns'
import { ContributionsFeedChunkCard } from '../components/FeedChunkCard'
import FeedChunk from '../components/FeedChunk'
import LoadingFeedChunk from '../components/LoadingFeedChunk'
import LoadingSwitch from '../../../core/components/loading-switch/LoadingSwitch'
import {PrimaryButton} from '../../../core/components/unilink/index'

const EmptyContributions = ({classNames, isPersonalProfile}) => (
  <div className={classNames}>
    <div className='no-lessons'>
      <div className='no-lessons__container'>
        {
          isPersonalProfile
            ? <h3>You haven't contributed yet.</h3>
            : <h3>This user hasn't contributed yet.</h3>
        }
        {
          isPersonalProfile
            ? <span>When you add or edit explanations to lessons, or submit solutions to problems, they will show up here.</span>
            : <span>When they add or edit explanations to lessons, or submit solutions to problems, they will show up here.</span>
        }
        <PrimaryButton className={`no-lessons__button`} to='/subjects'>
          View Subjects
        </PrimaryButton>
      </div>
    </div>
  </div>
)

const bucketContributionsByDate = contributions => {
  const chunks = {}
  const ordering = []
  //const dateFormat = 'ddd, DD MMM YYYY hh:mm:ss '

  let today = new Date()
  today.setHours(0,0,0,0)
  let yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  yesterday.setHours(0, 0, 0, 0)

  for (let c of contributions) {
    const { ts, ...cEntry } = c
    const date = new Date(ts)
    date.setHours(0,0,0,0)
    let timeago = distanceInWords(today, date, {addSuffix: true})
    if (isEqual(today, date)) {
      timeago = 'Today'
    } else if (isEqual(yesterday, date)) {
      timeago = 'Yesterday'
    }
    if (!Object.prototype.hasOwnProperty.call(chunks,timeago)) {
      chunks[timeago] = []
      ordering.push(timeago)
    }
    chunks[timeago].push(cEntry)
  }
  return { chunks, ordering }
}

class VisibleContributionsFeedComponent extends React.PureComponent {
  render() {
    const {
      contributions,
      hasContributions,
      showMore,
      isFetching,
      showPrivacy,
      isPersonalProfile
    } = this.props
    let activeState = <EmptyContributions isPersonalProfile={isPersonalProfile} classNames='gridcontainer profile-empty' />
    let bucketedContributions = []
    let canLoadMore = false
    const isLoading = isFetching && !hasContributions
    if (hasContributions) {
      bucketedContributions = bucketContributionsByDate(contributions.entries)
      canLoadMore = contributions.entries.length < contributions.totalNum
      activeState = (
        <ProfileFeed canLoadMore={canLoadMore} showMore={showMore}>
          {bucketedContributions.ordering.map((timeago, index) => (
            <FeedChunk
              key={timeago}
              timeago={timeago}
              entries={bucketedContributions.chunks[timeago]}
              FeedChunkCard={ContributionsFeedChunkCard}
              isFirst={index === 0}
              isPrivate={false}
              showPrivacy={showPrivacy}
            />
          ))}
        </ProfileFeed>
      )
    }
    const loadingState = (
      <ProfileFeed canLoadMore={false} showMore={null}>
        <LoadingFeedChunk
          numEntries={2}
          isFirst={true}
          isPrivate={false}
          showPrivacy={showPrivacy} />
      </ProfileFeed>
    )
    return (
      <LoadingSwitch
        activeState={activeState}
        loadingState={loadingState}
        isLoading={isLoading}
      />
    )
  }
}

const mapStateToProps = state => ({
  contributions: state.getIn(['profile', 'contributions']),
  isFetching: state.getIn(['profile', 'contributions', 'isFetching']),
  hasContributions: !state
    .getIn(['profile', 'contributions', 'entries'])
    .isEmpty(),
  isPersonalProfile: parseInt(state.getIn(['profile', 'userInfo', 'id'])) === parseInt(state.getIn(['session', 'user', 'id']))
})
const VisibleContributionsFeed = connect(mapStateToProps)(
  toJS(VisibleContributionsFeedComponent)
)

export default VisibleContributionsFeed



// WEBPACK FOOTER //
// ./src/domains/user/containers/VisibleContributionsFeed.js